<template>
  <div>
    <el-row :gutter="24" class="panel-group" style="margin: 0">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col" v-if="cardInfo != null">
        <div class="card-panel">
          <div class="card-panel-description" :style="{ marginTop: cardInfo.marginTop}">
            <!-- 标题1 -->
            <div class="card-panel-text">{{ cardInfo.titleOne?cardInfo.titleOne:''  }}</div>
            <div class="card-panel-num">{{ cardInfo.numOne !== undefined && cardInfo.numOne !== null?cardInfo.numOne:'' }}</div>

            <!-- 标题2 -->
            <div class="card-panel-text">{{ cardInfo.titleTwo?cardInfo.titleTwo:'' }}</div>
            <div class="card-panel-num">{{ cardInfo.numTwo !== undefined && cardInfo.numTwo !== null?cardInfo.numTwo:'' }}</div>

            <!-- === KPI 对比率 === -->
            <div v-if="cardInfo.ratioLabel && isValidRatio" class="card-panel-kpi" :style="{ color: kpiColor }">
              {{ cardInfo.ratioLabel }}: {{ ratioValue }} %
            </div>
          </div>
        </div>
      </el-col>

      <el-col v-else>
        <div class="card-panel-text no-data">暂无数据</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'CoreCard',
  props: {
    cardInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // 判断是否可以安全计算比率
    isValidRatio() {
      const { numOne, numTwo,ratioLabel } = this.cardInfo;
      if(!ratioLabel){
        return false;
      }
      return (
        numOne != null &&
        numTwo != null &&
        typeof numOne === 'number' &&
        typeof numTwo === 'number' &&
        numTwo !== 0
      );
    },
    // 计算比率值（保留两位小数）
    ratioValue() {
      if (!this.isValidRatio) return 0;
      return (this.cardInfo.numOne / this.cardInfo.numTwo*100).toFixed(2);
    },
    // 动态颜色：≥1 绿色，<1 红色
    kpiColor() {
      return this.ratioValue >= 100 ? '#67C23A' : '#F56C6C';
    },

  }
}
</script>

<style lang="scss" scoped>
.panel-group {
  margin-top: 10px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    height: 180px; // 稍微加高一点，容纳 KPI
    cursor: pointer;
    position: relative;
    overflow: hidden;
    padding: 24px;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
      transform: translateY(-2px);
    }

    .card-panel-description {
      text-align: center;

      .card-panel-text {
        line-height: 20px;
        color: #666;
        font-size: 14px;
        margin-bottom: 6px;
      }

      .card-panel-num {
        font-size: 20px;
        color: #333;
        font-weight: 600;
        margin-bottom: 8px;
      }

      .card-panel-kpi {
        margin-top: 8px;
        padding-top: 8px;
        font-size: 13px;
        font-weight: 600;
        border-top: 1px dashed #dcdfe6;
      }

      .ratio-warning {
        color: #e6a23c;
      }

      .ratio-disabled {
        color: #c8c9cc;
      }
    }
  }
/* 当只有一个项目时，让它居中 */
.card-panel-description.single-item {
 margin-top: 20%;
}
  .no-data {
    text-align: center;
    color: #999;
    font-size: 14px;
    padding: 20px 0;
  }
}
</style>
